import React, {Component} from 'react';
import { Modal} from 'react-bootstrap';
import GoogleMapPopup from './GoogleMapPopup';
import $ from 'jquery';
import {DATE_FORAMT,API_BASE_URL} from '../../constants';
import {getWayPoints} from '../../util/APIUtils';
import NotFound from '../../common/NotFound';
import ServerError from '../../common/ServerError';
import Loading from '../../common/Loading';

//const origin = {latitude: 37.3318456, longitude: -122.0296002};
//const destination = {latitude: 37.771707, longitude: -122.4053769};
//const GOOGLE_MAPS_APIKEY = 'AIzaSyBPy3G7jB2iYJu9ccGeYuPBy-CVG6dKvks';

class GoogleMapForm extends Component {

	constructor(props) {
		super(props);
		this.state = {
			modalShow: false,
			resourseId:'',
			currentDate:'',
			mapresult:{},
			geopoints:[],
			isOptimizeButton:true,
			optimizesuccess:false

		};
		this.handleClose = this.handleClose.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.loadGooglePoint = this.loadGooglePoint.bind(this);
		this.isOptimizeSuccess = this.isOptimizeSuccess.bind(this);
		
        
	}

	componentDidMount() {

	}

	isOptimizeSuccess(){
       // alert('call');
		this.setState({ optimizesuccess: true });
		this.props.updateCalendarEvents();//remove event and update
	
	}

	handleClose() {
		this.setState({ modalShow: false,resourseId:'',currentDate:'' });
	}

	handleSave() {
		this.setState({ modalShow: false });
	}


	componentWillMount() {
		document.body.addEventListener('click', this.handleClick);
	}

	handleClick(event) {
		if(event.target.classList.contains('buildroutes')) {
			var resourseId = event.target.getAttribute('data-resourseId');
			var currentDate = $('#calendar').fullCalendar('getDate');
            currentDate= currentDate.format(DATE_FORAMT);
			//alert("buildclick"+resourseId);
			if(resourseId){

                this.setState({ modalShow: true,currentDate:currentDate})
                this.loadGooglePoint(resourseId,currentDate);

			}


		}

	}

	loadGooglePoint(resourseId,currentDate){
        var fields={};
         fields["peopleId"] = resourseId;
         fields["date"] =currentDate;
           getWayPoints(fields)
                .then(response => {
                   //  console.log(response);
                     
                     var isOptimizeButton=false;
                     if(response.geopoints && response.geopoints.length>0){
                          isOptimizeButton=true;
                     }

                     this.setState({optimizesuccess:false,mapresult: response,isOptimizeButton:isOptimizeButton,resourseId:resourseId,geopoints:response.geopoints});

                }).catch(error => {
                if (error.status === 404) {
                    this.setState({
                        notFound: true,
                    });
                } else {
                    this.setState({
                        serverError: true,
                    });
                }
            });

   }


	render(){


       if (this.state.notFound) {
            return <NotFound />;
        }

        if (this.state.serverError) {
            return <ServerError />;
        }

        if (this.state.loading) {
            //return 'Loading...'
            return <Loading />;
        }

       
        let peopleImageUrl='../static/assets/images/people.png';

        if(this.state.mapresult.peopleImageUrl!==''){
        	 peopleImageUrl=API_BASE_URL+this.state.mapresult.peopleImageUrl;
        }
        const geopoints=this.state.geopoints;
      //  console.log(geopoints);

		return (<Modal show={this.state.modalShow} onHide={this.handleClose}   dialogClassName="modal-90w" >
                              <Modal.Header closeButton>
                               

                               {this.state.optimizesuccess
						        ? <div className="alert alert-success" style={{width:'100%'}}> <i className="fa fa-map-marker"></i> Your scheduled job successfully optimize.
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">×</span> </button>
                                </div>
						        : ''
						      }
                                


                              </Modal.Header>
                              <Modal.Body>

                               <form>
                                    <div className="row">
                                         <div className="col-md-4">


                                               <div className="card card-outline-info1">

					                            <div className="card-body" style={{backgroundColor:'#f1f1f1'}}>
					                              <h4 className="card-title"><b>Build Route for {this.state.mapresult.searchDate}</b></h4>
					                                  <div className="row">
					                                            <div className="col-md-12">
					                                                   <div className="form-group">
					                                                  <h6 className="card-title">Date</h6>

                                                                       <div className="input-group">
                                                                       <div className="input-group-append">
							                                                    <span className="input-group-text"><i className="icon-calender"></i></span>
							                                                </div>
					                                                   <input type="text" readOnly id="fromdate" name="fromdate"  className="form-control" value={this.state.currentDate} />

					                                                   </div> </div>
					                                            </div>
					                                   </div>


                                                        <div className="row">
					                                            <div className="col-md-12">
					                                                   <div className="form-group">
					                                                      <h6 className="card-title">Starting Point</h6>
					                                                       <div className="font_app font_bold"><i className="fa fa-map-marker"></i> {this.state.mapresult.peopleAddress}</div>

					                                                   </div>
					                                            </div>
					                                   </div>
<div className="row">
 <div className="col-md-12">
  <div className="form-group">
      {
          geopoints.map(function(item, i){
          	return (
                <div className="accordion acc" key={i} id={"geopoints_accordion"+i} role="tablist" aria-multiselectable="true">





                  <div className="card m-b-0">

                  <div className="google-events" data-eventpriority={item.priority} role="tab" id={'headingOne'+i}>
					  {item.title} ({item.jobduration})<br/><small>{item.address}</small>


              <a data-toggle="collapse" href={'#collapseOne'+i} aria-expanded="true" aria-controls={'collapseOne'+i} className="">

                  <i className="ti-menu threeline" style={{color:'white'}}></i>
              </a>
              </div>

              <div id={'collapseOne'+i} data-parent={"#geopoints_accordion"+i} className="collapse hide" aria-labelledby={'headingOne'+i}>
                  <div className="card-body font_app">
                    <span className="font_bold"> Title :</span>  {item.title}<br/>
					 <span className="font_bold">From Date : </span> {item.fromDateAsString}  <span className="font_bold">In Time : {item.fromTimeAsString}  </span><br/>
					 <span className="font_bold">To Date : </span> {item.toDateAsString}  <span className="font_bold">Out Time : {item.toTimeAsString}  </span><br/>
					 <span className="font_bold">Address :</span> {item.address} 


                     
              </div>
              </div>
              </div>
              </div>
			);
          })
      }

</div>
</div>
</div>




					                                   <div className="row">
					                                            <div className="col-md-12">
					                                                   <div className="form-group">
					                                               <h6 className="card-title">Total: {this.state.mapresult.totalhours}</h6>


					                                                   </div>
					                                            </div>
					                                   </div>

					                                  <div className="row">
					                                            <div className="col-md-12">
					                                                   <div className="form-group">
																			    <h6 className="card-title">Travel Mode</h6>

														                          <select id="mode" className="form-control">
																							      <option value="DRIVING">Driving</option>
																							      <option value="WALKING">Walking</option>
																							      <option value="BICYCLING">Bicycling</option>

																					     </select>
					                                                   </div>
					                                            </div>
					                                   </div>

					                                    <div className="row">
					                                            <div className="col-md-12">
                                                                       
                                                                     {this.state.isOptimizeButton ? (
        <input type="button"  id="optimizeroute" value="Build Route" className="btn btn-rounded btn-primary agility-green"/>) : ('')}  


								                                        <input type="button" onClick={this.handleClose} id="close" value="Close" className="btn btn-rounded btn-inverse"/>

					                                            </div>
					                                    </div>


					                             </div>

                                                  </div>

                                         </div>

                                          <div className="col-md-8">
						                                    <div className="card card-outline-info1">

											                            <div className="card-body" >
																		 <div className="row">
																	     <div className="col-md-12">

											                              <h4 className="card-title" style={{float:'left'}}>Way Map Directions</h4>

											                             <div style={{float:'right'}}>
						                                                    <img src={peopleImageUrl} style={{float:'left',borderRadius:'100%',border:'2px solid #54555e'}}  height="35px" width="35px" alt="user" className="profile-pic"/>
						                                                <h4 style={{float:'right'}}><b>&nbsp;&nbsp;{this.state.mapresult.peopleName}</b></h4>
											                             </div>
																		</div></div>



											                                          <div className="row">
												                                        <div className="col-md-12">
											                                                            <GoogleMapPopup   mapresult={this.state.mapresult}   isSuccessOptimize={this.isOptimizeSuccess} resourseId={this.state.resourseId}  currentDate={this.state.currentDate}/>
											                                            </div>
											                                          </div>
											                              </div>


						                                         </div>




                                         </div>


                                    </div>
                                </form>


                              </Modal.Body>
                            
                            </Modal>);
	}
}
export default GoogleMapForm;